var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inclusive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.19572 1.87105L3.06825 5.096C2.47464 5.40844 2.47464 6.25844 3.06825 6.57087L9.19572 9.79585C9.43864 9.92369 9.72897 9.92369 9.97189 9.79585L16.0994 6.57087C16.693 6.25844 16.693 5.40844 16.0994 5.096L9.97189 1.87105C9.72897 1.74318 9.43864 1.74318 9.19572 1.87105Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.50035 9.16675L2.46683 9.20025C2.0698 9.59733 2.17109 10.2654 2.66798 10.5269L9.1956 13.9625C9.43852 14.0904 9.72885 14.0904 9.97177 13.9625L16.4994 10.5269C16.9963 10.2654 17.0976 9.59733 16.7005 9.20025L16.667 9.16675",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.50035 13.3333L2.46683 13.3668C2.0698 13.7638 2.17109 14.4319 2.66798 14.6934L9.1956 18.129C9.43852 18.2569 9.72885 18.2569 9.97177 18.129L16.4994 14.6934C16.9963 14.4319 17.0976 13.7638 16.7005 13.3668L16.667 13.3333",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveIcon);
export default __webpack_public_path__ + "static/media/comprehensive-icon.8ec87b5f6a3a669f53c74c515e269765.svg";
export { ForwardRef as ReactComponent };